











































































import Vue from 'vue' // eslint-disable-line no-unused-vars

export default {
  name: 'login-modal',
  components: {
  },
  data() {
    return {
      email: undefined,
      password: undefined,
      stayConnected: true,
      expired: false,
      badLogin: false,
      error: false,
      loading: false,
      success: false,
      showPassword: false
    }
  },
  mounted() {
  },
  methods: {
    close() {
      this.$store.dispatch('runtime/closeModal')
    },
    go(destination) {
      this.$store.dispatch('runtime/showModal', destination)
    },
    contribute() {
      window.openLink(window.portalLink('users/contribute/'))
    },
    login() {
      this.loading = true
      this.badLogin = false
      this.error = false
      this.expired = false
      Vue.http.post(Vue.config.server + '/api/user/login', { email: this.email, password: this.password })
      .then(response => {
        if (response.body.redirect !== undefined) {
          document.location = response.body.redirect
          return
        }
        this.$store.dispatch('auth/login', response.body.token)
        this.success = true
        setTimeout(this.close, 1000)
      })
      .catch(response => {
        switch (response.status) {
          case 401:
            this.badLogin = true
            break
          case 403:
            this.expired = response.body.expiration
            break
          default:
            this.error = true
        }
      })
      .finally(() => {
        this.loading = false
      })
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    }
  },
  computed: {
    expirationDate() {
      if (!this.expired) return null
      return Vue.options.filters.moment(this.expired, 'll')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/login.vue